import type { AppFeatureDefinition } from "@nasam/kernel";
import { createMaintenanceRoutes } from "./presentation/routes";

const SCHEDULE_MAINTENANCE_VIEW =
  "maintenance.maintenance_management.schedule_maintenance.view";

export const maintenanceFeature: AppFeatureDefinition = {
  id: "maintenance",
  version: "0.1.0",
  titleKey: "common:businessModules.maintenance",
  icon: "Wrench",
  basePath: "/maintenance",
  requiredPermissions: [SCHEDULE_MAINTENANCE_VIEW],
  navigation: [
    {
      id: "maintenance",
      titleKey: "common:businessModules.maintenance",
      icon: "Wrench",
      placement: "rail",
      order: 50,
      children: [
        {
          id: "maintenance-schedules",
          titleKey: "maintenance:nav.schedules",
          placement: "drawer",
          order: 10,
          path: "/maintenance/schedules",
          requiredPermissions: [SCHEDULE_MAINTENANCE_VIEW],
        },
      ],
    },
  ],
  routes: (context) => createMaintenanceRoutes({ context }),
  i18n: {
    namespace: "maintenance",
    load: {
      en: () => import("./i18n/en"),
      ar: () => import("./i18n/ar"),
    },
  },
  permissionCatalog: [
    {
      segment: "maintenance",
      labelKey: "maintenance:permissions.maintenance",
      children: [
        {
          segment: "maintenance_management",
          labelKey: "maintenance:permissions.maintenanceManagement",
          children: [
            {
              segment: "schedule_maintenance",
              labelKey: "maintenance:permissions.scheduleMaintenance",
              actions: [
                { id: "view", labelKey: "maintenance:actions.view" },
                { id: "create", labelKey: "maintenance:actions.create" },
                { id: "update", labelKey: "maintenance:actions.update" },
                { id: "delete", labelKey: "maintenance:actions.delete" },
              ],
            },
          ],
        },
      ],
    },
  ],
};
